<template>
  <div>
    <helpmadya/>
  </div>
</template>

<script>
import  helpmadya from 'cp/min-component/helpmadya.vue'
  export default {
    name:'helpemadya',
    components:{
      helpmadya
    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/dashboard/rules.vue